import MediaLoader from './MediaLoader';

export default MediaLoader;
